import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { BikeService } from '../../services/bike.service';

@Component({
  selector: 'my-bikes',
  template: require('./bikes.component.html'),
  styles: [require('./bikes.component.scss')]
})

export class BikesComponent implements OnInit{

  skip = 0;
  limit = 100;

  constructor(private router:Router, public bikeService:BikeService) {

  }

  ngOnInit(): void {
    this.bikeService.list = [];
    this.bikeService.getList(this.skip, this.limit);
  }

  loadMore(){
    this.skip += this.limit;
    this.bikeService.getList(this.skip, this.limit);
  }

  openBike(id:string){
    this.router.navigate(['/bike', id]);
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/home/pages/bikes/bikes.component.ts